import PropTypes from 'prop-types';
import { useMemo } from 'react';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import CouponsList from 'components/Coupons/CouponsList';
import ErrorBoundary from 'components/ErrorBoundary';
import GenericError from 'components/GenericError';

import { toStoreCouponsLink } from 'lib/links';
import placeholder from 'lib/placeholder';
import { couponQueryKeys } from 'lib/queryKeys';

import { getCouponsList } from 'services/coupon';
import { getStoreCouponsList } from 'services/store';

import LINKS from 'constants/links';

const COUPONS_LIMIT = 3;

const ManagedCouponsList = ({
  gaEventCategory,
  storeSlug,
  subtitle,
  title,
}) => {
  const { queryFn, queryKey } = useMemo(() => {
    const currQueryFn = ({ page }, { signal }) =>
      storeSlug
        ? getStoreCouponsList(
            { limit: COUPONS_LIMIT, page, storeSlug },
            { signal }
          )
        : getCouponsList(
            { limit: COUPONS_LIMIT, after: page, sort: 'best' },
            { signal }
          );
    const currQueryKey = storeSlug
      ? couponQueryKeys.listByStore({ storeSlug, finished: false })
      : couponQueryKeys.list({ sortType: 'best' });

    return {
      queryFn: currQueryFn,
      queryKey: currQueryKey,
    };
  }, [storeSlug]);

  return (
    <ErrorBoundary
      fallback={
        <GenericError message={placeholder('errors.couldNotLoadCouponsList')} />
      }
    >
      <section>
        {(title || subtitle) && (
          <div className="mb-4 flex flex-col gap-1 lg:mb-6">
            {title && <Heading size="size4">{title}</Heading>}
            {subtitle && <Text>{subtitle}</Text>}
          </div>
        )}
        <CouponsList
          gaEventCategory={gaEventCategory}
          queryFn={queryFn}
          queryKey={queryKey}
          seeMoreButtonLink={
            storeSlug ? toStoreCouponsLink(storeSlug) : LINKS.COUPONS
          }
          shouldShowTruePagination={false}
          withCouponStoreCover
        />
      </section>
    </ErrorBoundary>
  );
};

ManagedCouponsList.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  storeSlug: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default ManagedCouponsList;
